import { TimelineStore } from "../../store/TimelineStore";
import {TIMELINE_RULER_TICK_WIDTH_PX} from "../../config/config";

export function convertTimeToUnits(time: number): number {
  const timelineZoom = TimelineStore.zoom;

  const ratio = TIMELINE_RULER_TICK_WIDTH_PX * timelineZoom;
  return time * ratio;
}
